import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { AppComponent } from './app/app.component';
import { authInterceptor } from './app/auth.interceptor';
import { rotas } from './app/app.routes';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(rotas),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !/localhost|127\.0\.0\.1/.test(window.location.hostname),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(FormsModule)
  ]
}).catch((err) => console.error(err));
